export const Audit = {
    IbConfigSuperiorIb: '上级IB',
    IbConfigIbRole: 'IB角色',
    IbConfigResultRemark: '详情',
    IbConfigApplicant: '申请人',
    IbConfigSystemRemark: '系统提示内容',
    IbConfigStatusProcessing: '处理中',
    IbConfigStatusDone: '处理完成',
    IbConfigStatusFailed: '处理失败',
    IbConfigStatusRejected: '审核拒绝',
    IbConfigStatusPendingAudit: '等待送审',
    IbConfigStatusAuditing: '审批中',
    IbConfigStatusPending: '待执行',
    IbConfigOperatorName: '工单提交人',
    IbConfigSubmitSource: '提交来源',
    IbConfigSubmitterSelf: '本销售',
    IbConfigSubmitterSubordinate: '下级销售',
    IbConfigAccountUuid: '客户UUID',
    IbConfigSuperiorIbUuid: '上级IB UUID',
    // [meegle:14347943] 工单列表 Tab / 账户列 / IB UUID 查询项
    IbConfigTabUpgrade: '升级IB',
    IbConfigTabRebate: 'IB返佣配置',
    IbConfigClientAccount: '客户账户',
    IbConfigIbAccount: 'IB账户',
    IbConfigIbUuid: 'IB UUID',
    // [越权治理] 详情页链接无效 / 非本人链接时的空态
    IbConfigTicketUnavailable: '工单不存在或无权查看',
    IbConfigBackToList: '返回工单列表',
    IbConfigSourceAdmin: 'BSS Admin端',
    IbConfigSourceSales: 'BSS 销售端',
    IbConfigBizRebate: 'IB返佣配置',
    IbConfigBizUpgrade: 'IB升级',
    IbConfigCurrentInfo: '当前信息',
    IbConfigLinkTitle: '开户权限链接',
    IbConfigLinkSummary: '共 {total} 条，新增 {added} 条',
    IbConfigLinkName: '链接名称',
    IbConfigLinkSource: '来源',
    IbConfigLinkDefault: '默认',
    IbConfigLinkNew: '新增',
    IbConfigLinkExisting: '现有',
    IbConfigRebateTitle: '返佣策略明细',
    IbConfigRebateCount: '共 {count} 项',
    IbConfigRebateAccountType: '账户类型',
    IbConfigRebateSubType: '子类型',
    IbConfigRebateColValue: '数值 / 外汇数值',
    IbConfigRebateColMetal: '贵金属数值',
    IbConfigSymbolRuleTitle: '品种组返佣规则',
    IbConfigSymbolRuleCount: '{count} 条规则',
    IbConfigSymbolRuleEmpty: '暂无品种组规则',
    IbConfigStatsTitle: '配置统计',
    IbConfigStatsLinkTotal: '链接总数',
    IbConfigStatsLinkNew: '新增链接',
    IbConfigStatsActiveSubType: '生效子类型',
    IbConfigSummaryTitle: '申请概要',
    IbConfigTicketTypeLabel: '工单类型',
    IbConfigTicketTypeUpgradeSub: '升级普通IB',
    IbConfigTicketTypeUpgradeTop: '升级顶级IB',
    IbConfigTicketTypeModifyStrategy: '返佣配置',
    IbConfigTopGroup: '顶级组组别',
    IbConfigRebateDesc: '子类型集合由全部链接去重生成。MT4 的 STP / ECN 与 MT5 的 ECN 为单一数值，贵金属列不适用。',
    IbConfigSymbolRuleDesc: '提交时生成的最细粒度规则。',
    IbConfigSubmitterRequired: '请选择您要查询的下级销售',
    IbConfigClientId: '客户ID',
};
